import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import "../styles/MatchDaysList.css";
import { parse } from "date-fns";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Button } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import WarningModal from "./WarningModal";

import { putItem } from "../../../utils/api";
import { matchSubmitSuccess } from "../redux/actions";

function toUTCISOString(date) {
    return new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    ).toISOString();
}

export default function DateComponent({ matches = [], matchDay }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [manuallyEdited, setManuallyEdited] = useState(false);
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);

    useEffect(() => {
        const parsedDates = matches
            .map((m) => m.scheduleDate?.split("T")[0])
            .filter(Boolean)
            .map((d) => parse(d, "yyyy-MM-dd", new Date()));

        if (parsedDates.length) {
            setToDate(new Date(Math.max(...parsedDates)));
            if (!manuallyEdited) {
                setFromDate(new Date(Math.min(...parsedDates)));
            }
        }
    }, [matches, manuallyEdited]);

    const handleClick = async () => {
        if (!fromDate) return;

        setIsLoading(true);

        try {
            const submitMatchUrl = `/admin/api/dhbmatchdays/${matchDay.matchDayKey}`;

            const responseMatches = await putItem(submitMatchUrl, {
                gameDayMatches: matchDay.gameDayMatches,
                gameDayDate: toUTCISOString(fromDate),
            });

            dispatch(matchSubmitSuccess(responseMatches));
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            setIsOverlayOpen(false);
        }
    };

    const openModal = () => {
        setIsOverlayOpen(true);
    };

    const closeModal = () => {
        setIsOverlayOpen(false);
    };

    return (
        <div className="date__wrapper">
            <span className="date__title">
                {t("gamedays.matchday_block.calculated_dates")}
            </span>
            <div className="date-items__wrapper">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        slotProps={{ textField: { size: "small" } }}
                        value={fromDate}
                        label={t("gamedays.matchday_block.from_date")}
                        onChange={(date) => {
                            setFromDate(date);
                            setManuallyEdited(true);
                        }}
                        disabled={!matches.length}
                    />
                </LocalizationProvider>
                <span className="date__dash">—</span>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={t("gamedays.matchday_block.to_date")}
                        slotProps={{ textField: { size: "small" } }}
                        value={toDate}
                        disabled
                    />
                </LocalizationProvider>
            </div>
            <Button
                variant="contained"
                onClick={openModal}
                disabled={!matches.length}
                sx={{
                    width: "fit-content",
                    margin: "5px",
                }}
            >
                {t("gamedays.matchday_block.from_date_apply")}
            </Button>

            {isOverlayOpen && (
                <WarningModal
                    isOpen={isOverlayOpen}
                    confirmHandler={handleClick}
                    cancelHandler={closeModal}
                    loading={isLoading}
                />
            )}
        </div>
    );
}
